// Currencies Stripe reports in whole units instead of hundredths.
// https://docs.stripe.com/currencies#zero-decimal
const ZERO_DECIMAL_CURRENCIES = new Set([
  'bif',
  'clp',
  'djf',
  'gnf',
  'jpy',
  'kmf',
  'krw',
  'mga',
  'pyg',
  'rwf',
  'ugx',
  'vnd',
  'vuv',
  'xaf',
  'xof',
  'xpf',
]);

// Currencies Stripe reports in thousandths.
// https://docs.stripe.com/currencies#three-decimal
const THREE_DECIMAL_CURRENCIES = new Set(['bhd', 'jod', 'kwd', 'omr', 'tnd']);

/**
 * Convert a Stripe amount (smallest currency unit) to the currency-unit
 * value expected by conversion tracking (e.g. 9999 usd -> 99.99).
 */
export const stripeAmountToValue = (amountTotal: number, currency: string) => {
  const code = currency.toLowerCase();
  if (ZERO_DECIMAL_CURRENCIES.has(code)) {
    return amountTotal;
  }
  if (THREE_DECIMAL_CURRENCIES.has(code)) {
    return Number((amountTotal / 1000).toFixed(3));
  }
  return Number((amountTotal / 100).toFixed(2));
};
